import { createSelector } from 'reselect'
import { isEqual } from 'lodash'
import { RootStoreState } from '@src/models/app.types'

export const allEventsStoreSelector = (state: RootStoreState) => state.allEvents

export const allEventsCalendarDateSelector = createSelector(
  allEventsStoreSelector,
  (allEventsStore) => allEventsStore.calendar,
  {
    memoizeOptions: {
      resultEqualityCheck: isEqual,
    },
  },
)
